import { changePassword, activeUser } from './fetch';

var form = function() {
  const passInp = document.getElementById('password-inp');
  const rePassInp = document.getElementById('re-password-inp');
  const buttonGoto = document.getElementById('area-logado-button');
  const checkboxs = document.querySelectorAll('.checkbox');
  const termoCheckbox = document.getElementById('aceitar-termos');

  let validation = {
    agreeWithTerms: false,
    passIsTheSame: false,
    termsChecked: false,
    newsChecked: false,
  };

  function showHideEyeOnInput() {
    const listOfInputs = [passInp, rePassInp];

    listOfInputs.forEach((inp) => {
      inp.addEventListener('keyup', (event) => {
        const { target } = event;
        const { value } = target;

        if (value.length >= 1) {
          target.parentNode.querySelector('.input__icon').classList.remove('input--hide');
        } else {
          target.parentNode.querySelector('.input__icon').classList.add('input--hide');
        }
      });
    });
  }

  function showPassword() {
    const listOfInputs = [passInp, rePassInp];

    listOfInputs.forEach((inp) => {
      const hideIcon = 'fa-eye-slash';
      const icon = inp.parentElement.querySelector('.fas');
      let isHide = true;

      icon.addEventListener('click', () => {
        inp.type = isHide ? 'text' : 'password';
        inp.classList[isHide ? 'remove' : 'add']('input--font2x');
        // if () {
        //   inp.classList.remove(isHide ? 'input--font2x' : '')
        // } else {
        //   inp.classList.remove(isHide ? 'input--font2x' : '')
        // }

        icon.classList.remove(isHide ? 'fa-eye' : 'fa-eye-slash');
        icon.classList.add(isHide ? 'fa-eye-slash' : 'fa-eye');
        isHide = !isHide;
      });
    });
  }

  function validateRepeatedAndSequentialNumber(seq, rep) {
    if (seq === false) return false;
    if (rep === false) return false;

    if (seq === null || rep === null) {
      return null;
    }

    return true;
  }

  function checkPasswordStrength(value) {
    const regex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");


    if (value.length === 0) {
      return false;
    } else if (regex.test(value)) {
      return true;
    }
  }

  function setupCheckbox() {
    if (termoCheckbox.checked) {
      validation.termsChecked = validation.agreeWithTerms = termoCheckbox.checked;
      enabledGotoButton(passInp.value);
    }

    checkboxs.forEach((check) => {
      check.addEventListener('change', (event) => {
        if (event.target.name === 'termos') {
          let isChecked = (event.target.name === 'termos' && event.target.checked);
          validation.termsChecked = validation.agreeWithTerms = isChecked;
        }

        if (event.target.name === 'novidades') {
          validation.newsChecked = (event.target.name === 'novidades' && event.target.checked);
        }

        enabledGotoButton(passInp.value);
      });
    });
  }

  function validate() {
    const {
      agreeWithTerms,
      passIsTheSame,
      termsChecked,
    } = validation;

    // se o termo for aceito e lido
    if ((agreeWithTerms && termsChecked) && passIsTheSame) {
      return true;
    }

    return false;
  }



  function validatePassword() {
    validation.passIsTheSame = (passInp.value === rePassInp.value);

    // A string tem que ter 8 ou mais caracteres
    const minCaracteres = new RegExp('^(?=.{8,})');

    // Verifica se a string tem um caracter expecial
    const specialRegex = new RegExp(/(?=.*[-+_!@#$%^&*., ?])/);

    // A string tem que ter ao menos um numero e uma letra
    const numberLetterRegex = new RegExp('^(?=.*[a-z])(?=.*[0-9])');

    // Verifica se a string contém um caracter em caixa alta
    const uppercaseRegex = new RegExp(/(?=.*[A-Z])/);

    //
    const repeatRegex = new RegExp(/(.)\1{3}/);


    passInp.addEventListener('keyup', (event) => {
      const { value } = event.target;

      validation.passIsTheSame = (value === rePassInp.value);

      if (!validation.passIsTheSame) {
        if (rePassInp.value !== '')
          rePassInp.classList.add('input--error');
      } else {
        rePassInp.classList.remove('input--error');
      }

      document.querySelector('.tips__minchar').classList.add('hide');
      document.querySelector('.tips__special').classList.add('hide');
      document.querySelector('.tips__number').classList.add('hide');
      document.querySelector('.tips__uppercase').classList.add('hide');

      if (minCaracteres.test(value)) {
        document.querySelector('.tips__minchar').classList.remove('hide');
      }

      if (specialRegex.test(value)) {
        document.querySelector('.tips__special').classList.remove('hide');
      }

      if (numberLetterRegex.test(value)) {
        document.querySelector('.tips__number').classList.remove('hide');
      }

      if (uppercaseRegex.test(value)) {
        document.querySelector('.tips__uppercase').classList.remove('hide');
      }

      enabledGotoButton(value);
    });

    rePassInp.addEventListener('keyup', (event) => {
      const { value } = event.target;

      validation.passIsTheSame = (value === passInp.value);

      if (!validation.passIsTheSame) {
        rePassInp.classList.add('input--error');
      } else {
        rePassInp.classList.remove('input--error');
      }

      enabledGotoButton(passInp.value);
    });
  }

  function enabledGotoButton(value) {
    if (validate() && checkPasswordStrength(value)) {
      buttonGoto.classList.remove('button--disabled');
    } else {
      buttonGoto.classList.add('button--disabled');
    }
  }

  function setFormToken() {
    const inp = document.getElementById('user-token');
    const param = new URLSearchParams(location.search);
    const token = param.get('linkId');
    const actId = param.get('actId');

    if (Boolean(actId && token)) {
      inp.value = token;
      activeUser(actId);
    } else {
      if (location.hostname !== 'localhost') {
        window.location.assign('/portal/portal-vr/login');
      }
    }
  }


  function submitForm() {
    const form = document.getElementById('form-change-password');

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const token = document.getElementById('user-token').value;
      const password = document.getElementById('password-inp').value;
      const checkedPassword = document.getElementById('re-password-inp').value;
      const error = document.querySelector('.error');
      const errorMsg = error.querySelector('.error__text');

      changePassword({
        idLinkDesbloqueio: token,
        novaSenha: password,
        confirmaNovaSenha: checkedPassword,
      })
        .then(() => {
          window.location.assign('/portal/portal-vr/login');
        })
        .catch(err => {
          error.classList.remove('error--hide');
          error.setAttribute('aria-hidden', 'false');
          errorMsg.innerHTML = err.messages[0].description;

          window.setTimeout(() => {
            error.classList.add('error--hide');
            error.setAttribute('aria-hidden', 'true');
          }, 7000);
        })
    });
  }

  window.eventBus.addEvent('agreeTerms', ({ agree }) => {
    validation.agreeWithTerms = agree;
    validation.termsChecked = agree;

    enabledGotoButton(passInp.value);
  });


  setFormToken();
  showHideEyeOnInput();
  showPassword();
  validatePassword();
  setupCheckbox();
  submitForm();
}

export default form;
